import React from "react"
import { useForm } from "react-hook-form"
import { Spinner } from "@/components/svg/Spinner"
import { gtmSignupStart } from "@/utils/gtm-tracking"

import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"

const SignUpForm = ({ isLoading, disabled, onSubmit, planName }) => {
  const { t } = useTranslation()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const handleFormSubmit = data => {
    // GTM tracking for email signup
    gtmSignupStart(planName || "", "Continue", "Get started")()

    onSubmit(data)
  }

  return (
    <form id="signup-form" onSubmit={handleSubmit(handleFormSubmit)}>
      <div className="form__field pb-4">
        <div
          className={`text-input ${errors.emailAddress && "text-input--error"}`}
        >
          <input
            id={"emailAddress"}
            className={"text-input__input"}
            placeholder={t("signup.email-address-placeholder")}
            aria-invalid={errors.emailAddress ? "true" : "false"}
            disabled={disabled}
            {...register("emailAddress", {
              required: t("signup.email-address-error"),
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: t("signup.email-address-error"),
              },
            })}
            autoFocus
          />
          {errors.emailAddress && (
            <span role="alert">{errors.emailAddress.message}</span>
          )}
        </div>
      </div>

      <button
        className={"btn  btn--lg btn--full-width signup-modal__button"}
        disabled={disabled}
        aria-disabled={disabled}
        type="submit"
      >
        {isLoading ? (
          <Spinner className="signup-modal__button-loader" />
        ) : (
          t("common.get-started")
        )}
      </button>
    </form>
  )
}

export default SignUpForm
